import { Task } from './task';
export { Task } from './task';

type UpdateCallback<T> = (context: Context) => T;
type DrawCallback<T> = (data: T) => void;

interface Options {
  fps: number;
  duration: number;
}

interface Context {
  from: number;
  to: number;
  progress: number;
}

export class Animation<T extends {}> {
  protected from = 0;
  protected to = 0;
  protected progress = 0;
  private updateCallbacks: UpdateCallback<T>[] = [];
  private drawCallbacks: DrawCallback<T>[] = [];

  public constructor(task: Task, options: Options) {
    let data = {} as T;
    const incremental = 1 / options.fps / options.duration;

    task.update(() => {
      this.progress += incremental;

      if (this.progress > 1) {
        this.progress = 1;
      }

      this.updateCallbacks.forEach(callback => {
        data = callback({
          from: this.from,
          to: this.to,
          progress: this.progress,
        });
      });
    });

    task.draw(() => this.drawCallbacks.forEach(callback => callback(data)));
  }

  public change(to: number) {
    this.from = this.to;
    this.to = to;
    this.progress = 0;
  }

  public reset() {
    this.from = 0;
    this.to = 0;
    this.progress = 0;
  }

  public update(callback: UpdateCallback<T>) {
    this.updateCallbacks.push(callback);
  }

  public draw(callback: DrawCallback<T>) {
    this.drawCallbacks.push(callback);
  }
}
